<template>
  <div class="overlay-wrapper">
    <div v-if="news">
      <h2 v-html="news.DATA[id].NAME" />
      <div v-html="decodeHtml(news.DATA[id].DETAIL_TEXT)" />
    </div>
    <c-loading-overlay v-if="fetching" />
  </div>
</template>

<script>
import breadcrumbs from '../mixins/breadcrumbs'
import Notification from '../notification'
import apiService from '../apiService'
import CLoadingOverlay from '../components/ui/CLoadingOverlay'
import { decodeHtml } from '../helper'

export default {
  name: 'NewsDetail',
  components: { CLoadingOverlay },
  mixins: [breadcrumbs],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      news: null,
      fetching: true
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.fetching = true

      apiService.getPublicationsDetail('news', this.id)
        .then(response => {
          this.news = response.data
          this.$title = decodeHtml(response.data.DATA[this.id].NAME)
          this.breadcrumbTitleUpdate('NewsDetail', decodeHtml(response.data.DATA[this.id].NAME))
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить новость.'
          })
        })
        .finally(() => {
          this.fetching = false
        })
    },
    decodeHtml
  }
}
</script>
